import * as ApiFunctionCalls from '@/utils/ApiFunctionCalls';
import moment from 'moment';
var tokenData;
var timeTofech = 4;
try {
  if (localStorage.getItem('authUser')) {
    tokenData = JSON.parse(atob(localStorage.getItem('authUser')));
  } else {
    tokenData = [];
  }
} catch (error) {
  console.log(error);
}
const state = {
  tokenData: tokenData,
  // masterTokenData: JSON.parse(atob(localStorage.getItem('authBUser'))),
  clientTokenData: [],
  UserData: [],
  hostname:
    process.env.NODE_ENV === 'development'
      ? 'echodev.co'
      : window.location.hostname,
  projectsData: [],
  tasksData: [],
  SumTasks: [], // sum all pending tasks
  archivedTasks: [],
  formatedPorjectsData: [],
  meetingData: [],
  todos: [], // calendar days
  AllOrdesData: [], // storing all orders
  ordersData: [], // storying latest orders, the orders that are at least 30days old
  OrderDetailsId: [], // id or the order we want to get the details
  OrderDetails: [], // all details for a specific order, based on the id we have stored above
  archivedOrders: [], // storying oders that are older than 30 days
  SumOrders: [], // sum all pending orders
  AllTickets: [],
  tickets: [],
  ticketTypes: [],
  TicketDetailsId: [], // id for the ticket we want to get details
  TicketDetails: [], // details for a specific ticket based on the id we have stored above
  TicketThreads: [],
  archivedTickets: [], // tickets that have been resolved
  PentingResolvedTickets: [],
  CommLog: [],
  CommLogData: [],
  LogData: [],
  ActivitiesData: [],
  AllTransactions: [],
  AllInvoices: [],
  PaidInvoices: [],
  UnpaidInvoices: [],
  Announcments: [],
  Translations: [],
  Pages: [],
  Employees: [], // About Us page
  Subscriptions: [],
  Sidebar: [],
  CompanyDetails: [], // About Us page
  Users: [],
  Files: [],
  TicketFiles: [],
  ApiPage: []
};
// ---------------------------------------------MUTATIONS -----------------------------------------------------------------
const mutations = {
  // setTokenData (state, data) {
  //   state.tokenData = data
  // },
  setUserData (state, data) {
    state.UserData = data;
  },
  setProjectsData (state, data) {
    state.projectsData = data;
  },
  setTasksData (state, data) {
    state.tasksData = data;
  },
  setSumTasks (state, data) {
    state.SumTasks = data;
  },
  setAllOrdersData (state, data) {
    state.AllOrdesData = data;
    state.AllOrdesData.timestamp = moment();
  },
  setOrdersData (state, data) {
    state.ordersData = data;
  },
  setArchivedOrders (state, data) {
    state.archivedOrders = data;
  },
  SetOrderDetails (state, data) {
    state.OrderDetails = data;
  },
  setSumOrders (state, data) {
    state.SumOrders = data;
  },
  setMeetingData (state, data) {
    state.meetingData = data;
  },
  updateTaskList (state, data) {
    state.formatedPorjectsData = data;
  },
  updateTasksData (state, data) {
    state.tasksData.push(data);
  },
  fileterProjectTaks (state, data) {
    for (let i = 0; i < state.formatedPorjectsData.length; i++) {
      if (state.formatedPorjectsData[i].id === data[0].project_id) {
        state.formatedPorjectsData[i].tasks = data;
      }
    }
  },
  addNewTask (state, data) {
    state.formatedPorjectsData.map(project => {
      if (project.id === parseInt(data.project_id)) {
        project.tasks.push(data);
        // alert(data.Assignee)
      }
    });
    // console.log(state.formatedPorjectsData)
  },
  // addToArchive (state, data) {
  //   state.archivedTasks.map(archive => {
  //     archive.Assignee = data.contact_name
  //     archive.Complete = data.
  //     archive.Project =
  //     archive.Task = data.title
  //   })
  //   console.log(data)
  //   console.log(state.archivedTasks)
  // },
  setTodos (state, data) {
    state.todos = data;
  },
  setArchivedTasks (state, data) {
    state.archivedTasks = data;
  },
  SetAllTickets (state, data) {
    state.AllTickets = data;
    // state.AllTickets.timestamp = moment()
  },
  SetTickets (state, data) {
    state.tickets = data;
  },
  SetTicketTypes (state, data) {
    state.ticketTypes = data;
  },
  SetArchivedTickets (state, data) {
    state.archivedTickets = data;
  },
  SetTicketDetails (state, data) {
    state.TicketDetails = data;
    if (typeof data !== 'undefined') {
      state.TicketThreads = data.thread;
    }
  },
  SetPentingResolvedTickets (state, data) {
    state.PentingResolvedTickets = data;
  },
  SetCommLog (state, data) {
    state.CommLog = data;
    // state.CommLog.total = data.length
  },
  SetCommLogData (state, data) {
    state.CommLogData = data;
  },
  SetLogData (state, data) {
    state.LogData = data;
  },
  SetActivities (state, data) {
    state.ActivitiesData = data;
  },
  SetAllTransactionsData (state, data) {
    state.AllTransactions = data;
  },
  SetInvoices (state, data) {
    state.AllInvoices = data;
    state.AllInvoices.timestamp = moment();
  },
  SetPaidInvoices (state, data) {
    state.PaidInvoices = data;
  },
  SetUnpaidInvoices (state, data) {
    state.UnpaidInvoices = data;
  },
  changeUser (state, data) {
    state.tokenData = data;
  },
  SetAnnouncments (state, data) {
    state.Announcments = data;
  },
  SetTranslations (state, data) {
    state.Translations = data;
  },
  SetPages (state, data) {
    state.Pages = data;
  },
  SetEmployees (state, data) {
    state.Employees = data;
  },
  SetSubscriptions (state, data) {
    state.Subscriptions = data;
  },
  SetSidebar (state, data) {
    // console.log(data)
    state.Sidebar = data;
  },
  SetCompanyDetails (state, data) {
    // console.log(data)
    state.CompanyDetails = data;
  },
  SetUsers (state, data) {
    state.Users = data;
  },
  SetFiles (state, data) {
    state.Files = data;
  },
  SetTicketFiles (state, data) {
    state.TicketFiles = data;
  }
};
// ---------------------------------- ACTIONS -----------------------------------------------------------------
const actions = {
  async userRequest ({ commit, state }) {
    try {
      commit('setUserData', await ApiFunctionCalls.getUserData());
    } catch (error) {
      console.log(error);
    }
  },
  async getProjectsData ({ commit, state }) {
    commit('setProjectsData', await ApiFunctionCalls.getProjectsData());
  },
  async getTasksData ({ commit, state }) {
    commit('setTasksData', await ApiFunctionCalls.getTasksData());
  },
  async getSumTasks ({ commit, state }) {
    try {
      commit(
        'setSumTasks',
        ApiFunctionCalls.getDataLength(await ApiFunctionCalls.getTasksData())
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getFormatedProjects ({ commit, state }) {
    let projects = [];
    if (state.tasksData.length === 0 || state.projectsData.length === 0) {
      projects = ApiFunctionCalls.formatProjects(
        await ApiFunctionCalls.getProjectsData(),
        await ApiFunctionCalls.getTasksData()
      );
    } else {
      projects = ApiFunctionCalls.formatProjects(
        state.projectsData,
        state.tasksData
      );
    }
    commit('updateTaskList', projects);
  },
  async getMeetingData ({ commit, state }) {
    try {
      // let dt = await getMeetingData()
      commit('setMeetingData', await ApiFunctionCalls.getMeetingData());
    } catch (error) {
      console.log('setMeetingData: ' + error);
    }
  },
  async getCalendarDates ({ commit, state }) {
    try {
      // let dt = await getMeetingData()
      commit(
        'setTodos',
        await ApiFunctionCalls.getCalendarTodos(
          await ApiFunctionCalls.getMeetingDataStartOfYear()
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getAllOrdersData ({ commit, state }) {
    if (
      state.AllOrdesData.timestamp &&
      moment().diff(state.AllOrdesData.timestamp, 'minutes') < timeTofech
    ) {
    } else {
      try {
        commit('setAllOrdersData', await ApiFunctionCalls.getOrders());
      } catch (error) {
        console.log(error);
      }
      try {
        commit(
          'setOrdersData',
          await ApiFunctionCalls.getLatestOrders(state.AllOrdesData)
        );
      } catch (error) {
        console.log(error);
      }
      try {
        commit(
          'setArchivedOrders',
          await ApiFunctionCalls.getArchivedOrders(state.AllOrdesData)
        );
      } catch (error) {
        console.log(error);
      }
      console.log('Get All Orders');
    }
  },
  async getOrderDetails ({ commit, state }) {
    try {
      commit(
        'SetOrderDetails',
        await ApiFunctionCalls.getOrderDetails(
          state.OrderDetailsId,
          state.AllOrdesData
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getSumOrders ({ commit, state }) {
    try {
      commit(
        'setSumOrders',
        await ApiFunctionCalls.getDataLength(await ApiFunctionCalls.getOrders())
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getArchivedTasks ({ commit, state }) {
    try {
      commit(
        'setArchivedTasks',
        await ApiFunctionCalls.filterArchivedTasks(
          await ApiFunctionCalls.getTasksData(),
          await ApiFunctionCalls.getProjectsData()
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getAllTickets ({ commit, state }) {
    try {
      commit('SetAllTickets', await ApiFunctionCalls.getTicketsData());
    } catch (error) {
      console.log(error);
    }
    try {
      commit(
        'SetArchivedTickets',
        await ApiFunctionCalls.getFilteredTickets(state.AllTickets, 'resolved')
      );
    } catch (error) {
      console.log(error);
    }
    try {
      commit(
        'SetTickets',
        await ApiFunctionCalls.getFilteredTickets(
          state.AllTickets,
          'unresolved'
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getPentingResolvedTickets ({ commit, state }) {
    try {
      commit(
        'SetPentingResolvedTickets',
        await ApiFunctionCalls.getPentingResolvedTickets(
          await ApiFunctionCalls.getTicketsData()
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getTickets ({ commit, state }) {
    try {
      commit(
        'SetTickets',
        await ApiFunctionCalls.getFilteredTickets(
          await ApiFunctionCalls.getTicketsData(),
          'unresolved'
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getTicketTypes ({ commit, state }) {
    try {
      commit('SetTicketTypes', await ApiFunctionCalls.getTicketTypes());
    } catch (error) {
      console.log(error);
    }
  },
  async getArchivedTickets ({ commit, state }) {
    try {
      commit(
        'SetArchivedTickets',
        await ApiFunctionCalls.getFilteredTickets(
          await ApiFunctionCalls.getTicketsData(),
          'resolved'
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getTicketDetails ({ commit, state }) {
    try {
      commit(
        'SetTicketDetails',
        await ApiFunctionCalls.getTicketDetails(
          state.TicketDetailsId,
          state.AllTickets
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getUpdatedTicketDetails ({ commit, state }) {
    try {
      commit(
        'SetTicketDetails',
        await ApiFunctionCalls.getTicketDetails(
          state.TicketDetailsId,
          await ApiFunctionCalls.getTicketsData()
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getCommLogData ({ commit, state }) {
    try {
      commit(
        'SetCommLog',
        await ApiFunctionCalls.getFilteredCommLogData(
          await ApiFunctionCalls.getCommLogData(),
          'resolved'
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getCommLog ({ commit, state }) {
    try {
      commit('SetCommLogData', await ApiFunctionCalls.getCommLogData());
    } catch (error) {
      console.log(error);
    }
  },
  async getLogData ({ commit, state }) {
    try {
      commit('SetLogData', await ApiFunctionCalls.getLogData());
    } catch (error) {
      console.log(error);
    }
  },
  async getActiviesData ({ commit, state }) {
    try {
      commit(
        'SetActivities',
        await ApiFunctionCalls.formatActivities(
          await ApiFunctionCalls.getActivityData()
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getAllTransactionsData ({ commit, state }) {
    try {
      commit(
        'SetAllTransactionsData',
        await ApiFunctionCalls.formatAllTransactionsData(
          await ApiFunctionCalls.getAllTransactionsData()
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getInvoices ({ commit, state }) {
    if (
      state.AllInvoices.timestamp &&
      moment().diff(state.AllInvoices.timestamp, 'minutes') < timeTofech
    ) {
    } else {
      try {
        commit('SetInvoices', await ApiFunctionCalls.getInvoices());
      } catch (error) {
        console.log(error);
      }
      try {
        commit(
          'SetUnpaidInvoices',
          await ApiFunctionCalls.filterInvoices(state.AllInvoices, 'unpaid')
        );
      } catch (error) {
        console.log(error);
      }
      try {
        commit(
          'SetPaidInvoices',
          await ApiFunctionCalls.filterInvoices(state.AllInvoices, 'paid')
        );
      } catch (error) {
        console.log(error);
      }
      console.log('Get Invoices');
    }
  },
  async getAnnouncments ({ commit, state }) {
    try {
      commit('SetAnnouncments', await ApiFunctionCalls.getAnnouncments());
    } catch (error) {
      console.log(error);
    }
  },
  async getTranslations ({ commit, state }) {
    try {
      commit('SetTranslations', await ApiFunctionCalls.getTranslations());
    } catch (error) {
      console.log(error);
    }
  },
  async getPages ({ commit, state }) {
    try {
      commit('SetPages', await ApiFunctionCalls.getPages());
    } catch (error) {
      console.log(error);
    }
  },
  async getEmployees ({ commit, state }) {
    try {
      commit('SetEmployees', await ApiFunctionCalls.getEmployees());
    } catch (error) {
      console.log(error);
    }
  },
  async getSubscriptions ({ commit, state }) {
    try {
      commit('SetSubscriptions', await ApiFunctionCalls.getSubscriptions());
    } catch (error) {
      console.log(error);
    }
  },
  async getMenus ({ commit, state }) {
    try {
      commit('SetSidebar', await ApiFunctionCalls.getMenu());
    } catch (error) {
      console.log(error);
    }
  },
  async getCompanyDetails ({ commit, state }) {
    try {
      commit('SetCompanyDetails', await ApiFunctionCalls.getCompanyDetails());
    } catch (error) {
      console.log(error);
    }
  },
  async getUsers ({ commit, state }) {
    try {
      commit(
        'SetUsers',
        await ApiFunctionCalls.formatUsersData(
          await ApiFunctionCalls.getUsers()
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getFiles ({ commit, state }) {
    try {
      commit(
        'SetFiles',
        await ApiFunctionCalls.formatFiles(await ApiFunctionCalls.getFiles())
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getTicketFiles ({ commit, state }) {
    try {
      commit(
        'SetTicketFiles',
        await ApiFunctionCalls.formatFiles(
          await ApiFunctionCalls.getTicketFiles()
        )
      );
    } catch (error) {
      console.log(error);
    }
  }
};
// ------------------------------------------------ GETTERS -----------------------------------------------------------------
const getters = {
  getMytasksData: state => state.formatedPorjectsData,
  hostname: state => state.hostname,
  clientTokenData: state => state.clientTokenData
};

// GET PROJECTS DATA & FORMAT
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/data.js